import {
  APP_CODE,
  HttpService,
  ProtectionProvider,
  ProtectionService,
} from "@sportal/api";

export const makeProtectionService = (
  http: HttpService,
  baseUrl: string
): ProtectionService => {
  return new ProtectionService(
    new ProtectionProvider(http, baseUrl, APP_CODE.SB)
  );
};
